import React, { FC, useState } from 'react'
import { UseCaseTypes } from '../../../../constants/blogUseCase'
import { DownArrow, XIcon } from '../../../../constants/svg'
import Button from '../../../global/button'
import GlobalContainer from '../../../global/globalContainer'
import Typography from '../../../global/typography'
import { BlogNavContainer } from './style'
import { BlogNavLinks } from './subcomponent'

type Props = {
  blogNav?: any
  pagePath?: string
  isNonNavigationPage?: boolean
  useCase?: string
}

const BlogNavigation: FC<Props> = ({ blogNav, pagePath, isNonNavigationPage, useCase }) => {
  if (!blogNav?.menuGroups) return null
  if (!useCase) useCase = UseCaseTypes.MAIN_BLOG
  const [mobileDrawerOpen, setMobileDrawerOpen] = useState(false)
  const [secondaryDrawerOpen, setSecondaryDrawerOpen] = useState(false)

  const handleMobileNavClick = () => setMobileDrawerOpen(!mobileDrawerOpen)
  const handleSecondaryDrawerClick = () => setSecondaryDrawerOpen(!secondaryDrawerOpen)
  const handleSubscribeClick = (event: any) => event.preventDefault()

  return (
    <BlogNavContainer data-cy="BlogNavigation" $mobileDrawerOpen={mobileDrawerOpen}>
      <GlobalContainer className="BlogNav__Global-Container">
        <div className="BlogNav__Mobile-Menu-Switcher" onClick={handleMobileNavClick}>
          {mobileDrawerOpen ? <XIcon /> : <DownArrow />}

          <Typography className="BlogNav__Mobile-Menu-Title font__inter" type="bodyXS">
            {mobileDrawerOpen ? 'Close' : 'UiPath Blog'}
          </Typography>
        </div>

        <div className="BlogNav__Inner">
          <BlogNavLinks
            blogNav={blogNav}
            pagePath={pagePath || ''}
            isNonNavigationPage={isNonNavigationPage || false}
            secondaryDrawerOpen={secondaryDrawerOpen}
            handleSecondaryDrawerClick={handleSecondaryDrawerClick}
          />

          {(useCase === UseCaseTypes.MAIN_BLOG || useCase === UseCaseTypes.COMMUNITY_BLOG) && (
            <Button
              icon={true}
              text="Subscribe"
              type="text-link"
              size="small"
              theme="light"
              clickHandler={handleSubscribeClick}
              className="BlogNav__Subscribe SubscribeModal__Trigger"
            />
          )}
        </div>
      </GlobalContainer>
    </BlogNavContainer>
  )
}

export default BlogNavigation
